export const S3_ENDPOINT_URL= process.env.NODE_ENV == "development" ? "http://127.0.0.1:9001" : "https://prep50.sfo3.digitaloceanspaces.com"
export const IS_DEVELOPMENT = false;
